<template>
  <div class="top">
    <div class="top-right" style="float:right;padding:17px 17px 0">
      <Button
        type="primary"
        class="search-button"
        style="margin-left:10px;"
        @click="examineOpen"
      >审批通过</Button>
    <Button
      type="primary"
      class="search-button"
      style="margin-left:10px;"
      @click="visible = true"
    >审批驳回</Button>
  </div>
  <!-- 驳回原因 -->
  <Modal
  :mask-closable="false"
  :loading="loading"
  v-model="visible"
  @on-ok="reasonback()"
  title="审批驳回">
     <Form
     label-position="right"
     ref="resetLostForm"
     :model="resetLostForm"
     :label-width="80">
      <FormItem
        label="驳回原因"
        label-for="reason"
      >
        <Input
         v-model="resetLostForm.reason"
         placeholder=""></Input>
      </FormItem>
    </Form>
  </Modal>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  props: {
    orderDetail: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      visible: false,
      loading: true,
      resetLostForm: {
        reason: ''
      }
    }
  },
  computed: {
    ...mapState('user', [
      'user'
    ])
  },
  methods: {
    examineOpen () {
      let url = ''
      if ([1, 2, 3].indexOf(this.user.sysrole)) {
        url = '/order/platformMgrAuditPass'
      } else if ([4, 5].indexOf(this.user.sysrole)) {
        url = '/order/agentAuditPass'
      }
      let data = {
        orderId: this.orderDetail.id
      }
      this.$http.put(url, data).then(res => {
        if (res.success) {
          let msg = '审核成功'
          this.$Message.success(msg)
          this.$router.back()
        } else {
          this.$Message.error(res.message)
        }
      })
    },
    reasonback () {
      let data = {
        orderId: this.orderDetail.id,
        reason: this.resetLostForm.reason
      }
      let url = ''
      if ([1, 2, 3].indexOf(this.user.sysrole)) {
        url = '/order/platformMgrAuditPass'
      } else if ([4, 5].indexOf(this.user.sysrole)) {
        url = '/order/agentAuditPass'
      }
      this.$http.put(url, data).then(res => {
        if (res.success) {
          let msg = '审核驳回成功'
          this.$Message.success(msg)
          this.visible = false
          this.resetLostForm.reason = ''
          this.$router.back()
        } else {
          this.$Message.error(res.message)
        }
      })
    }
  }
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// src/pages/orderManage/agOrderList/OrderDetailTop.vue